import { updateOrganizations } from '../../graphql/mutations/grid/organizations';
import { rumCounters } from '../../service/RUM/RUM';
import { GdUpdateOrganizationInput, UpdateOrganizations } from '../../typings/graphql-grid';
import { BaseMutationExecutor } from '../BaseMutationExecutor/BaseMutationExecutor';

export class OrganizationMutationExecutor extends BaseMutationExecutor {
    public bulkUpdateOrganizations(input: GdUpdateOrganizationInput[], login: string) {
        return this.awaitExecute<UpdateOrganizations>(
            updateOrganizations,
            input,
            login,
            {},
            rumCounters.backendBulkUpdateOrganizations
        );
    }
}
